import AvatarCFA from 'pages/CFA/components/AvatarCFA';
import AvatarConvention from 'pages/CFA/components/AvatarConvention';

const Header = ({ idUser, type = "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA", profilImageUrl }) => {
  return (
    <div style={{ height: 120 }} >
      {type === 'convention' ? (
        <AvatarConvention profilImageUrl={profilImageUrl} height={100} width={100} />
        ) : (
        <AvatarCFA idUser={idUser} height={100} width={100} />
        )
      }
    </div>
  );
};

export default Header;